import { Controller } from '@hotwired/stimulus';
import { slideToggle } from '../helpers';

export default class extends Controller {
    connect() {
        this.clickHandler = this.onToggleClick.bind(this);

        this.element
            .querySelectorAll('.accordion-item--expandable .accordion-head')
            .forEach((head) => head.addEventListener('click', this.clickHandler));
    }

    disconnect() {
        this.element
            .querySelectorAll('.accordion-item--expandable .accordion-head')
            .forEach((head) => head.removeEventListener('click', this.clickHandler));
    }

    onToggleClick(event) {
        const head = event.currentTarget;
        const item = head.closest('.accordion-item');
        const body = item?.querySelector('.accordion-body');

        if (!item || !body) return;

        slideToggle(body);
        item.classList.toggle('active');

        if (this.element.dataset.scroll === 'true') {
            setTimeout(() => {
                body.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            }, 300);
        }
    }
}
